// Charge la base commune
import './common.js'

// Scripts librairies
import { dtectMap } from './js/libs/utils'

// Styles custom
import './scss/pages/groundsDetail.scss'

// Grounds map
async function getGroundsMap ($f) {
  $f.load()
  import(/* webpackChunkName: "groundsMap", webpackPrefetch: true */ './js/components/groundsMap.js').then(() => {
    /* global Waypoint */
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Responsive Tabs
async function getRTabs () {
  import(/* webpackChunkName: "responsiveTabs" */ './js/components/responsiveTabs.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Custom Lists
async function getCustomLists () {
  import(/* webpackChunkName: "customLists" */ './js/components/customLists.js').then(() => {
    Waypoint.refreshAll()
  })
}

// Contact Form
async function getCForm ($f) {
  $f.load()
  import(/* webpackChunkName: "contactForm" */ './js/components/contactForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agencies Search Form
async function getAsForm ($f) {
  $f.load()
  import(/* webpackChunkName: "agenciesSearchForm" */ './js/components/agenciesSearchForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// Agency autocomplete
async function getAgenciesAutocomplete ($f) {
  import(/* webpackChunkName: "agenciesAutocomplete" */ './js/components/agenciesAutocomplete.js').then(module => {
    module.agenciesAutocomplete.init($f)
  })
}

// Offers Alert Form
async function getOaForm ($f) {
  $f.load()
  import(/* webpackChunkName: "offersAlertForm" */ './js/components/offersAlertForm.js').then(() => {
    Waypoint.refreshAll()
    $f.load(false)
  })
}

// actions principales communes à toutes les pages
$(document).ready(function () {
  // à exécuter une fois la GMap API correctement chargée
  dtectMap(function () {
    // gestion de la carte des terrains
    const $c1 = $('#map-grounds')
    if ($c1.length) {
      $c1.waypoint(function () {
        getGroundsMap($c1)
        this.destroy()
      }, {
        offset: '100%'
      })
    }
  })

  // responsive tabs
  $('#desc-tabs').waypoint(function () {
    getRTabs()
    this.destroy()
  }, {
    offset: '100%'
  })

  // gestion des scrollbars améliorées
  const $c2 = $('.custom-lists')
  if ($c2.length) {
    $c2.waypoint(function () {
      getCustomLists()
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion du formulaire de contact
  const $c3 = $('form[name="cForm"]')
  if ($c3.length) {
    $c3.waypoint(function () {
      getCForm($c3)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion de la recherche d'agences la plus proche
  const $c4 = $('form[name="asForm"]')
  if ($c4.length) {
    $c4.waypoint(function () {
      getAsForm($c4)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // filtres des agences autocomplete
  $('form[name="asForm"] input[name="location"]').on('click keyup focus', function () {
    $(this).blur().off().attr('disabled', '').val('Veuillez patienter...')
    getAgenciesAutocomplete($(this).parents('form'))
  })

  // formulaire d'inscription aux alertes terrains/offres
  const $c5 = $('form[name="oaForm"]')
  if ($c5.length) {
    $c5.waypoint(function () {
      getOaForm($c5)
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // gestion des alertes BS
  const $c6 = $('.alert')
  if ($c6.length) {
    $c6.waypoint(function () {
      import(/* webpackChunkName: "alertBs" */ './scss/components/alertBs.scss').then(() => {
        Waypoint.refreshAll()
      })
      this.destroy()
    }, {
      offset: '100%'
    })
  }

  // boutons d'action sur le terrain détaillé
  $('#track-f').on('click', () => { // event sur bouton financement : track event google analytics
    /* global ga */
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Financement terrain', 'Clic') }
    /* global gtag */
    if (typeof (googletag) !== 'undefined') { gtag('event', 'financing_ground') }
  })
  $('#track-c').on('click', () => { // event sur bouton contact : track event google analytics
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Contacter terrain', 'Clic') }
    if (typeof (googletag) !== 'undefined') { gtag('event', 'contact_ground') }
  })
  $('#track-m').on('click', () => { // event sur bouton modèle
    if (typeof (googleanalytics) !== 'undefined') { ga('send', 'event', 'Recherche modele', 'Clic') }
    if (typeof (googletag) !== 'undefined') { gtag('event', 'model_search') }
  })

  // ancre
  $.each($('.scroll'), function (i, elem) {
    $(elem).off().on('click', function (e) {
      const t = ($(e.target).is('a')) ? this.hash : $(this).attr('target')
      e.preventDefault()
      if ($(t).length > 0) {
        const h = $('#header').height()
        const p = $('#sub-nav').height()
        $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' }, function () {
          $('html').animate({ scrollTop: $(t).offset().top - h - p - 10 }, { duration: 300, easing: 'linear' })
        })
      }
    })
  })
})
